module.exports = __webpack_public_path__ + "static/media/markey-logo.cf84732d.png";